const ids = {};
const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const randomString = (l = 10) => {
  let str = [];
  while (str.length < l - 1) {
    str.push(chars.substr(Math.floor(chars.length * Math.random()), 1));
  }
  return str.join("");
};
export const idRepo = () => {
  let id = randomString();
  while (ids[id]) {
    id = randomString();
  }
  ids[id] = true;
  return id;
};
